import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { isSupabaseConfigured } from '../lib/supabase';
import '../styles/global.css';

const basename: string = (import.meta as any).env.BASE_URL || '/';

const container = document.getElementById('root');

if (container) {
  const root = ReactDOM.createRoot(container);

  if (!isSupabaseConfigured) {
    // A build without VITE_SUPABASE_* would otherwise render a normal-looking
    // app where every login silently fails.
    root.render(
      <div className="screen min-h-[100dvh] h-full">
        <div className="screen-card text-center">
          <div className="section-title">Konfigurasi aplikasi belum lengkap</div>
          <div className="subtitle">
            Hubungi pengelola aplikasi.
          </div>
        </div>
      </div>
    );
    console.error(
      'Missing VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY at build time. ' +
        'Rebuild with a populated .env — see docs/deployment.md.'
    );
  } else {
    root.render(
      <React.StrictMode>
        <BrowserRouter basename={basename}>
          <App />
        </BrowserRouter>
      </React.StrictMode>
    );
  }
}

